// src/utils/navigation.ts
import { useNavigate } from "react-router-dom";
export var useAppNavigation = function () {
    var navigate = useNavigate();
    var redirectTo = function (path) { return navigate(path); };
    return { redirectTo: redirectTo };
};
